import { Asset } from "../../classes";

const AssetModule = {
  namespaced: true,
  state: {
    assets: [],
    asset: {}
  },
  actions: {
    getAssets: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await Asset.getAssets(params);
        commit("setAssets", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    getAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await Asset.getAsset(params);
        commit("setAsset", data);
        return data;
      } catch (e) {
        throw e;
      }
    },
    createAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await Asset.createAsset(params);
        // dispatch("getAssets", { parameter: data?.subParameter });
        return data;
      } catch (e) {
        throw e;
      }
    },
    updateAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await Asset.updateAsset(params);
        // dispatch("getAssets", { parameter: data?.subParameter });
        return data;
      } catch (e) {
        throw e;
      }
    },
    removeAsset: async ({ dispatch, commit, rootGetter }, payload) => {
      try {
        const params = Object.assign({}, payload);
        const data = await Asset.removeAsset(params);
        // dispatch("getAssets", { parameter: data?.subParameter });
        return data;
      } catch (e) {
        throw e;
      }
    }
  },
  getters: {
    getAsset: state => {
      return state.asset;
    },
    getAssets: state => {
      return state.assets.map(i => {
        return i;
      });
    }
  },
  mutations: {
    setAsset: (state, payload) => {
      state.asset = payload;
    },
    setAssets: (state, payload) => {
      state.assets = payload;
    }
  }
};

export default AssetModule;
